/**
 * Constants for the Chatbot module
 */

export const WEBCHAT_STYLE_OPTIONS = {
  backgroundColor: '#F0F0F0',
  bubbleBackground: '#FFFFFF',
  bubbleBorderColor: '#E6E6E6',
  bubbleBorderRadius: 10,
  bubbleFromUserBackground: '#183440',
  bubbleFromUserBorderColor: '#183440',
  bubbleFromUserBorderRadius: 10,
  bubbleFromUserTextColor: 'white',
  botAvatarBackgroundColor: '#183440',
  userAvatarBackgroundColor: '#183440',
  hideScrollToEndButton: false,
  accent: '#183440',
  sendBoxBackground: '#FFFFFF',
  sendBoxBorderTop: '1px solid #E0E0E0',
  suggestedActionBackground: '#FFFFFF',
  suggestedActionBorderColor: '#183440',
  suggestedActionTextColor: '#183440',
  suggestedActionBorderRadius: '10px',
  timestampColor: '#888888',
  transcriptOverlayButtonBackground: 'rgba(107, 103, 206, 0.8)',
  transcriptOverlayButtonColor: 'white',
  primaryFont: '"Roboto", system-ui, -apple-system, "Segoe UI", sans-serif',
  sendBoxPlaceholderColor: '#888888',
  sendBoxTextColor: '#333333',
  botAvatarImage: '/img/icons/ChatBotConsark.svg',
  botAvatarInitials: 'CB',
  userAvatarImage: '',
  userAvatarInitials: 'ME',
};

export const CONNECTION_STATUSES = {
  CONNECTED: 2,
  FAILED: 4
};

export const LOCALIZED_STRINGS = {
  TEXT_INPUT_PLACEHOLDER: "Type your message here..."
};

/**
 * Direct Line API endpoint for token generation
 * Uses environment variable if available, otherwise falls back to default
 */
export const DIRECT_LINE_TOKEN_URL = process.env.VUE_APP_DIRECT_LINE_TOKEN_URL || 'https://directline.botframework.com/v3/directline/tokens/generate';

/**
 * UI Text constants
 */
export const UI_TEXT = {
  LOADING_CHAT: 'Loading chat...',
  RETRY_BUTTON: 'Retry',
  COMPONENT_NAME: 'Chatbot',
  RIGHT_PANEL: 'ArkAgent',
  WELCOME_TITLE: 'Hi, how are you doing today?',
  WELCOME_SUBTITLE: 'Ask me anything about your finance close data, reports, or analysis.',
  WELCOME_INPUT_PLACEHOLDER: 'Type your message here...'
};

/**
 * Error messages
 */
export const ERROR_MESSAGES = {
  FETCH_TOKEN_FAILED: 'Failed to fetch chat token. Please try again later.',
  INITIALIZE_CHAT_ERROR: 'Error initializing chat. Please try again later.',
  CONNECTION_FAILED: 'Connection to chat service failed. Please try again later.',
  CONNECTION_ERROR_PREFIX: 'Error connecting to chat service: ',
  INITIALIZE_WEBCHAT_ERROR: 'Failed to initialize chat: ',
  WEBCHAT_NOT_LOADED: 'WebChat library not loaded. Please try again.'
};

/**
 * Console log messages
 */
export const CONSOLE_MESSAGES = {
  DIRECTLINE_CONNECTION_STATUS: 'DirectLine connection status:',
  DIRECTLINE_CONNECTION_ERROR: 'DirectLine connection error:',
  INITIALIZE_WEBCHAT_ERROR: 'Error initializing WebChat:',
  FETCH_TOKEN_ERROR: 'Error fetching token:',
  WEBCHAT_NOT_INITIALIZED: 'WebChat or DirectLine not initialized',
  SESSION_EXPIRED: '[ChatBot]: Session expired, redirecting to login',
  LOGOUT_ERROR: '[ChatBot]: Logout error:'
};

/**
 * DOM selectors and class names
 */
export const DOM_SELECTORS = {
  WEBCHAT_CONTAINER: 'webchat',
  WEBCHAT_INPUT: '.webchat__send-box-text-box__input',
  SEND_BOX_MAIN: '.webchat__send-box__main',
  SEND_BUTTON: '.webchat__send-button',
  SUGGESTIONS_BUTTON: '.suggestions-button'
};

/**
 * DOM attributes and styles
 */
export const DOM_ATTRIBUTES = {
  WEBCHAT_HEIGHT: '100%',
  WEBCHAT_WIDTH: '100%',
  SUGGESTIONS_BUTTON_CLASS: 'suggestions-button',
  INPUT_EVENT_TYPE: 'input',
  INPUT_EVENT_BUBBLES: true
};

/**
 * WebChat configuration
 */
export const WEBCHAT_CONFIG = {
  LOCALE: 'en-US'
};

/**
 * Mutation Observer configuration
 */
export const OBSERVER_CONFIG = {
  CHILD_LIST: true,
  SUBTREE: true
};

/**
 * ChatSuggestions component constants
 */
export const CHAT_SUGGESTIONS_UI = {
  COMPONENT_NAME: 'ChatSuggestions',
  HEADER_TITLE: 'SUGGESTED PROMPTS',
  CLOSE_BUTTON: '✕',
  NO_SUGGESTIONS_MESSAGE: 'No suggestions available at the moment.'
};

/**
 * Application type aliases and mappings
 */
export const FLUX_ALIASES = ['flux', 'variance', 'varianceanalysis', 'va'];
export const FBC_ALIASES = ['fbc', 'financialclose', 'financial_close', 'financial close'];

/**
 * User role definitions for financial close operations
 */
export const ROLE_LIST = [
  { id: 'manager', name: 'Manager' },
  { id: 'preparer', name: 'Preparer' },
  { id: 'approver', name: 'Approver' },
];

/**
 * API endpoints
 */
export const API_ENDPOINTS = {
  LOGOUT: '/v2/auth/logout',
  TOOLS_CATALOG: '/v2/chatbot/toolscatalog'
};

/**
 * Route paths
 */
export const ROUTE_PATHS = {
  HOME: '/'
};

/**
 * Success messages
 */
export const SUCCESS_MESSAGES = {
  LOGOUT_SUCCESS: 'Logged out successfully'
};

/**
 * Delay timings (in milliseconds)
 */
export const TIMINGS = {
  SESSION_EXPIRED_DELAY: 2000
};

/**
 * Error codes
 */
export const ERROR_CODES = {
  WIDGET_TOKEN_EXPIRED: 'WIDGET_TOKEN_EXPIRED'
};
